import { createContext, useContext, ReactNode } from "react";
import { PackageType } from "../services/api/types/assignments/assignment";

interface AssignmentLayoutContextType {
  sidebarContent: ReactNode;
  setSidebarContent: (content: ReactNode) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  // undefined = not yet known (still loading) — the sidebar hides itself
  // until this resolves, rather than flashing SCORM styling by default.
  packageType: PackageType | undefined;
  setPackageType: (packageType: PackageType | undefined) => void;
}

const AssignmentLayoutContext =
  createContext<AssignmentLayoutContextType | undefined>(undefined);

export const useAssignmentLayout = (): AssignmentLayoutContextType | undefined =>
  useContext(AssignmentLayoutContext);

export { AssignmentLayoutContext };
